module.exports = __webpack_public_path__ + "img/spark_basket_03_opcion_2.b0bb0935.png";